function getOpt(dimensions, source) {
  return {
    tooltip: {},
    dataset: {
      dimensions: ["car", ...dimensions],
      source: source,
    },
    xAxis: {
      type: "category",
      axisLabel: {
        show: true,
        textStyle: {
          color: "#A6CAFF",
          fontSize: "16",
        },
        axisLine: {
          lineStyle: {
            color: "#8A9099",
            type: "dashed",
          },
        },
      },
    },
    yAxis: {
      axisLabel: {
        show: true,
        textStyle: {
          color: "#A6CAFF",
          fontSize: "16",
        },
      },
      splitNumber: 3,
      axisLine: {
        show: false,
      },
    },
    series: [
      { type: "bar", itemStyle: { color: "#00AEFF" } },
      { type: "bar", itemStyle: { color: "#FFB400" } },
      { type: "bar", itemStyle: { color: "#3CC93C" } },
    ],
  };
}

export default getOpt;
